
import sliderimage from "../../assets/Home/sliderimage.svg";

export const Slider = [
    {
        src: `${sliderimage}`,
        heading: "Multiple Gas Stations In Houston Texas",
        text: "Now and Forever is a premier chain of gas stations located across Houston.Now and Forever is a premier chain of gas stations located across Houston.",
        btn_text: "Nearest Store"
    },
    {
        src: `${sliderimage}`,
        heading: "Multiple Gas Stations In Houston Texas",
        text: "Now and Forever is a premier chain of gas stations located across Houston.Now and Forever is a premier chain of gas stations located across Houston.",
        btn_text: "Nearest Store"
    },
    {
        src: `${sliderimage}`,
        heading: "Multiple Gas Stations In Houston Texas",
        text: "Now and Forever is a premier chain of gas stations located across Houston.Now and Forever is a premier chain of gas stations located across Houston.",
        btn_text: "Nearest Store"
    },
];
